export default __webpack_public_path__ + "static/media/avatar-o.57966329.svg";